/**
 * The PostgREST `select` lists for product rows (`medpdb2` per market and the carousel views).
 * PostgREST has no negative select, so a column kept out of the browser is kept out by naming
 * every other one here; a product read never spells `select=*`.
 */

/** Every non-slot product column the browser may receive, in the table's column order. */
export const PRODUCT_SCALAR_COLUMNS: readonly string[] = [
  'EAN',
  'name',
  'brand',
  'category',
  'altcategory',
  'tags',
  'img',
  'page',
  'size',
  'prio',
  'locked',
  'history',
  'vendors',
  'desc',
  'usp1',
  'usp2',
  'usp3',
  'retail',
  'pclass',
  'mark',
  'act1',
  'act2',
  'fss',
  'dos',
  'contents',
  'alternates',
  'rating',
  'ratecount',
  'reviews',
  'sortrate',
  'updated_at',
  'brand_slug',
];

/** What the product card renders; `pclass` drives its prescription state. */
export const PRODUCT_CARD_COLUMNS: readonly string[] = [
  'name',
  'EAN',
  'page',
  'img',
  'price_1',
  'volprice_1',
  'volunit_1',
  'price_promo_percent_1',
  'availability_1',
  'category',
  'altcategory',
  'rating',
  'ratecount',
  'brand',
  'size',
  'pclass',
];

/** The `select` value: `columns`, each once, in order, without spaces. */
export function productSelect(columns: readonly string[]): string {
  return [...new Set(columns)].join(',');
}

/**
 * The slot columns consumer code still reads beside `offers`: slot 1 on the carousel and the
 * cards. Removed with those reads.
 */
export const FULL_ROW_SLOT_COLUMNS: readonly string[] = [
  'apoid_1',
  'price_1',
  'price_original_1',
  'price_promo_percent_1',
  'volprice_1',
  'volunit_1',
  'availability_1',
];

/** A whole product row as the browser may see it: the scalars, `offers` and the slot columns it still carries. */
export const FULL_PRODUCT_COLUMNS: string = productSelect([
  ...PRODUCT_SCALAR_COLUMNS,
  'offers',
  ...FULL_ROW_SLOT_COLUMNS,
]);

/** A carousel view row: carousel identity, the card's columns and vendor slot 1. */
export const CAROUSEL_PRODUCT_COLUMNS: string = productSelect([
  'c_id',
  'c_length',
  'c_name',
  'c_rand',
  'c_list',
  'name',
  'EAN',
  'brand',
  'category',
  'altcategory',
  'tags',
  'img',
  'page',
  'size',
  'rating',
  'ratecount',
  'apoid_1',
  'price_1',
  'price_original_1',
  'price_promo_percent_1',
  'volprice_1',
  'volunit_1',
  'availability_1',
]);
